<template>
  <div>
    <p v-if="loading">Loading...</p>
    <div v-else class="columns is-centered has-text-centered">
      <div class="column is-8">
        <b-tabs>
          <b-tab-item label="Users">
            <b-table
              :data="users"
              class="has-text-left"
              default-sort-direction="desc"
              default-sort="id"
              icon-pack="fas"
              per-page="15"
              :selected.sync="selectedUser"
              @select="getRecordings"
              paginated
            >
              <b-table-column
                field="id"
                label="Id"
                numeric
                sortable
                v-slot="props"
              >
                {{ props.row.id }}
              </b-table-column>
              <b-table-column
                field="email"
                label="Email"
                sortable
                v-slot="props"
              >
                {{ props.row.email }}
              </b-table-column>
              <b-table-column
                field="recordingsCount"
                label="Recordings"
                numeric
                sortable
                v-slot="props"
              >
                {{ props.row.recordingsCount }}
              </b-table-column>
            </b-table>
          </b-tab-item>

          <b-tab-item v-if="selectedUser" :label="selectedUser.email">
            <UserRecordingsTable :recordings="recordings" />
          </b-tab-item>
        </b-tabs>
      </div>
      <div class="column is-3">
        <GlobalStats :globalStats="globalStats" />
        <br />
        <LicenceCreation />
        <br />
        <RecordingsCleaner />
      </div>
    </div>
  </div>
</template>

<script>
import dataService from "../services/dataService";
import UserRecordingsTable from "@/components/Admin/UserRecordingsTable";
import RecordingsCleaner from "@/components/Admin/RecordingsCleaner";
import GlobalStats from "@/components/Admin/GlobalStats";
import LicenceCreation from "@/components/Admin/LicenceCreation";

export default {
  name: "Admin",
  components: {
    UserRecordingsTable,
    RecordingsCleaner,
    GlobalStats,
    LicenceCreation
  },
  data() {
    return {
      loading: true,
      users: [],
      selectedUser: undefined,
      recordings: [],
      globalStats: undefined
    };
  },
  methods: {
    async initialize() {
      this.loading = true;
      this.users = await dataService.getAllUsers();
      this.globalStats = await dataService.getGlobalStats();
      this.loading = false;
    },
    async getRecordings(newUser, oldUser) {
      if (newUser.email == oldUser?.email) {
        return;
      }
      this.recordings = await dataService.getAllRecordingsForUser(newUser.id);
    }
  },
  watch: {
    async $route() {
      await this.initialize();
    }
  },
  async created() {
    await this.initialize();
  }
};
</script>

<style lang="scss" scoped></style>
